import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COLLECTIONS, getCollectionPieces } from "../data/site";

function CollectionPreview({ collection }) {
  const pieces = getCollectionPieces(collection).slice(0, 3);
  const count = getCollectionPieces(collection).length;
  return (
    <Link
      to={`/collections/${collection.slug}`}
      className="group block border-t border-border pt-10 md:pt-14"
      data-testid={`collection-card-${collection.slug}`}
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start">
        <div className="md:col-span-4">
          <p className="label mb-3">{collection.eyebrow}</p>
          <h2 className="serif text-3xl md:text-5xl tracking-tight font-light leading-[1.05]">
            {collection.label}
          </h2>
          <p className="mt-5 text-[hsl(var(--ink-soft))] leading-relaxed">
            {collection.blurb}
          </p>
          <span className="mt-6 inline-flex items-center gap-2 label group-hover:text-foreground">
            View {count} {count === 1 ? "piece" : "pieces"}
            <ArrowUpRight className="h-3.5 w-3.5" />
          </span>
        </div>
        <div className="md:col-span-8 grid grid-cols-3 gap-3 md:gap-5">
          {pieces.length > 0 ? (
            pieces.map((p) => (
              <div key={p.piece.id} className="aspect-[4/5] overflow-hidden bg-[hsl(var(--surface))]">
                <img
                  src={p.piece.image}
                  alt={p.piece.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
                />
              </div>
            ))
          ) : (
            <p className="col-span-3 label text-[hsl(var(--ink-soft))]">
              No pieces currently match this collection.
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}

export default function Collections() {
  return (
    <div data-testid="collections-index">
      <header className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12 md:pb-16">
        <p className="label mb-4">Curator Collections</p>
        <h1 className="serif text-5xl md:text-7xl tracking-tight font-light leading-[1.02]">
          Ways In.
        </h1>
        <p className="mt-6 max-w-2xl text-[hsl(var(--ink-soft))] leading-relaxed text-lg">
          Hand-picked rooms across every series — grouped by budget, context,
          and studio season. Start where you feel most at home.
        </p>
      </header>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-32 space-y-16 md:space-y-24">
        {COLLECTIONS.map((c) => (
          <CollectionPreview key={c.slug} collection={c} />
        ))}
      </section>
    </div>
  );
}
